import { useApiClient } from '../composables/useApiClient.ts';

export default {
    lastForPeriod({ period }: { period: string }) {
        return useApiClient().get(`crms/documents-delivery/last-for-period/${ period }`);
    },
    setForSettlement({ delivery_date, evidence_period }) {
        return useApiClient().post('crms/subscription-settlements/documents-delivery-date', {
            delivery_date,
            evidence_period,
        });
    },
};
